import React from 'react';
import { FadeIn } from './FadeIn';
import { Rocket, Route, LayoutTemplate, LifeBuoy, Search } from 'lucide-react';
export function WhatYouGet() {
  const features = [{
    icon: <Rocket className="w-6 h-6 text-amber-500" data-id="element-189" />,
    title: 'El Protocolo de Inicio Rápido (P.I.R.)',
    description: 'Tres pasos exactos para pasar del sofá a la ejecución en menos de 60 segundos.'
  }, {
    icon: <Route className="w-6 h-6 text-amber-500" data-id="element-190" />,
    title: 'Técnica del Hilo de Ariadna',
    description: "El secreto para que el 'mañana' no sea una pesadilla de reinicio."
  }, {
    icon: <LayoutTemplate className="w-6 h-6 text-amber-500" data-id="element-191" />,
    title: 'Hackeo de Entorno',
    description: 'Cómo diseñar tu espacio para que la productividad sea la opción con menos resistencia.'
  }, {
    icon: <LifeBuoy className="w-6 h-6 text-amber-500" data-id="element-192" />,
    title: "El Manual del 'Modo Emergencia'",
    description: 'Qué hacer esos días donde el sistema simplemente no responde (sin destruirte emocionalmente).'
  }, {
    icon: <Search className="w-6 h-6 text-amber-500" data-id="element-193" />,
    title: 'Inventario de Fugas de Dopamina',
    description: 'Identifica qué está robando tu energía antes de que empieces a trabajar.'
  }];
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-194">
      <FadeIn data-id="element-195">
        <div className="text-center mb-16" data-id="element-196">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-197">
            Lo que encontrarás dentro
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto rounded-full" data-id="element-198"></div>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-199">
        {features.map((feature, index) => <FadeIn key={index} delay={index * 0.1} className={index === features.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto w-full' : ''} data-id="element-200">
            <div className="bg-slate-800/40 border border-slate-700/50 p-6 md:p-8 rounded-2xl flex gap-6 hover:bg-slate-800/60 transition-colors h-full" data-id="element-201">
              <div className="flex-shrink-0 mt-1" data-id="element-202">
                <div className="bg-amber-500/10 w-12 h-12 rounded-xl flex items-center justify-center" data-id="element-203">
                  {feature.icon}
                </div>
              </div>
              <div data-id="element-204">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-205">
                  {feature.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-206">
                  {feature.description}
                </p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}